import React from "react";
import { connect } from "react-redux";
import { InfoBar } from "ctia-ui";
import { getModelName } from "helpers/RequestHelper";

const BatteryTestResultsInfoBar = ({ request }) => {
  const reqInfo = [
    {
      key: "Supplier",
      value: request.vendor
    },
    {
      key: "Model Name/Number",
      value: getModelName(request)
    },
    {
      key: "Test",
      value: "Battery Compliance"
    }
  ];

  return <InfoBar show={true} data={reqInfo} />;
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(BatteryTestResultsInfoBar);
